import { useCallback, useEffect, useRef, useState } from 'react'

export default function useMyFormState() {
  const errsRef = useRef({});
  const formModelRef = useRef({});
  const [submitEnabled, setSubmitEnabled]     = useState(false);  
  const [locked, setLocked]                   = useState(false);
  const [reload, setReload] = useState(false);


  //------[  Update Form Field  ]------
  //
  const updateFormField = useCallback(async (path, value)=>{
    formModelRef.current[path] = value;
    //console.log('[useMyFormState updateFormField] [path: %s] [value: %s] Updated', path, value);
    setReload(prev => !prev);
    return true;
  },[]);


  const getFormModel = useCallback(()=> formModelRef.current, []);

  const isFormValid = useCallback(() => Object.keys(errsRef.current) < 1, []);
  
  const handleAddError = useCallback((error) => {
    errsRef.current[error] = true;
    setSubmitEnabled(false);
  }, []);
  
  const handleRemoveError = useCallback((error) => {
    delete errsRef.current[error];
    setSubmitEnabled(isFormValid() && !locked)
  }, [isFormValid, locked]);

  //
  // ---[  EFFECT  ]---
  //
  useEffect(()=>{    
    if (locked) {
      setSubmitEnabled(false);
    }
    else {
      setSubmitEnabled( isFormValid() );
    }

  },[locked, isFormValid, reload]);

  // --- Return ---

  return {
    updateFormField,
    handleAddError,
    handleRemoveError,
    submitEnabled,      setSubmitEnabled,
    locked,             setLocked,
    getFormModel,
    errs:errsRef.current, setReload, reload
  }
}
